import React, { useEffect, useState } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useDetectionExplorerStore } from '../DetectionExplorerStore'
import { DETECTION_EXPLORER_WINDOW_REFRESH_MS } from '../config'
import { clampToWindow, computeWindowBounds, WindowBounds } from '../timeWindow'
import { FiltersUI } from './FiltersUI'

const toDatetimeLocal = (date: Date) => {
    const pad = (n: number) => n.toString().padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

type Window = WindowBounds & { min: string; max: string }

const computeWindow = (): Window => {
    const bounds = computeWindowBounds()
    return { ...bounds, min: toDatetimeLocal(bounds.cutoff), max: toDatetimeLocal(bounds.now) }
}

export const FiltersContainer = () => {
    const [win, setWin] = useState<Window>(() => computeWindow())

    const from = useDetectionExplorerStore((s) => s.filters.from)
    const to = useDetectionExplorerStore((s) => s.filters.to)
    const changeFilter = useDetectionExplorerStore((s) => s.changeFilter)
    const timePreset = useDetectionExplorerStore((s) => s.timePreset)
    const setTimePreset = useDetectionExplorerStore((s) => s.setTimePreset)
    const viewMode = useDetectionExplorerStore((s) => s.viewMode)
    const setViewMode = useDetectionExplorerStore((s) => s.setViewMode)
    const imageRequestsOpen = useDetectionExplorerStore((s) => s.imageRequestsOpen)
    const toggleImageRequests = useDetectionExplorerStore((s) => s.toggleImageRequests)
    const { imageRetrieval } = useFlags()

    useEffect(() => {
        const id = setInterval(() => {
            setWin(computeWindow())
        }, DETECTION_EXPLORER_WINDOW_REFRESH_MS)
        return () => clearInterval(id)
    }, [])

    const handleStartChange = (v: string) => {
        const picked = new Date(v)
        if (Number.isNaN(picked.getTime())) return
        changeFilter('from', clampToWindow(picked, computeWindow()))
    }

    const handleEndChange = (v: string) => {
        const picked = new Date(v)
        if (Number.isNaN(picked.getTime())) return
        changeFilter('to', clampToWindow(picked, computeWindow()))
    }

    return (
        <FiltersUI
            startValue={toDatetimeLocal(from)}
            endValue={toDatetimeLocal(to)}
            minDateTime={win.min}
            maxDateTime={win.max}
            onStartChange={handleStartChange}
            onEndChange={handleEndChange}
            preset={timePreset}
            onPresetChange={setTimePreset}
            viewMode={viewMode}
            onViewModeChange={setViewMode}
            showImageRequests={Boolean(imageRetrieval)}
            imageRequestsOpen={imageRequestsOpen}
            onToggleImageRequests={toggleImageRequests}
        />
    )
}
